import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import LegalEntitiesImage from "src/modules/3rd-party-management/assets/images/legal-entities.svg";
import { Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const MergersAndAcquisitions = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const transactions = data?.mergers_and_acquisitions?.transactions || [];

    if (!hasNonEmptyArray(transactions)) {
        return null;
    }

    const label = (value) => {
        if (!value) {
            return '-';
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.en || value.de || value.long || value.short || '-';
    };

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('mergers-and-acquisitions')}
            className={activeAccordion === 'mergers-and-acquisitions' ? 'active' : ''}
            eventKey={'mergers-and-acquisitions'}
        >
            <Accordion.Header>
                <img src={LegalEntitiesImage} alt="" />
                <span>{t('Mergers & Acquisitions')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('Headline')}</th>
                                <th>{t('Type')}</th>
                                <th>{t('Role')}</th>
                                <th>{t('Phase')}</th>
                                <th>{t('Counterparties')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactions.map((tx, index) => (
                                <tr key={tx.id || index}>
                                    <td>
                                        {tx.date
                                            ? dateUtils.convertDateToDate(tx.date, INTERNATIONAL_DATE_FORMAT)
                                            : '-'}
                                    </td>
                                    <td>{label(tx.headline)}</td>
                                    <td>{label(tx.kind?.name) || label(tx.type?.name)}</td>
                                    <td>{label(tx.role?.en) || label(tx.role?.de) || tx.role?.label || '-'}</td>
                                    <td>{tx.phase || '-'}</td>
                                    <td>
                                        {(tx.counterparties || []).map((c) => c.name).filter(Boolean).join(', ') || '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(MergersAndAcquisitions);
